import React from 'react';
import './navBar.css';

function FooterNavBar() {
  return (
      <div className="nav-bottom-bar">
        <p>The Reel Draft uses data from TMDB. || Contact us: kate@thereeldraft.com || Created by Katie Brown</p>
      </div>
  );
}

export default FooterNavBar;
